import { AxiosResponse } from 'axios';
import { PAGE_SIZE } from '../../constants';
import api from '../../utils/api';
import { accessTypes } from '../../utils/AccessTypes';
import { isActive } from '../../utils/isActive';
import {
  GetInternalUsersResponse,
  InternalUser,
  InternalUserResponse,
  UserCompanies,
} from './types';
import { Company, Group } from '../../types';

export async function getInternalUsers(
  page?: number,
  pageSize?: number,
  search = '',
): Promise<GetInternalUsersResponse> {
  const { data, headers } = await api.get<InternalUser[]>('/user_corporate', {
    ...(page
      ? {
          params: {
            page,
            size: pageSize || PAGE_SIZE,
            ...(search ? { search } : {}),
          },
        }
      : {}),
  });

  const totalCount = Number(headers['x-total-count']);

  const users: InternalUserResponse[] = data.map(user => {
    return {
      ...user,
      isActive: isActive(user.status),
      type: 'Interno',
      formattedAccessType: accessTypes[user.accessType as keyof Object],
    };
  });

  return {
    users,
    totalCount,
  };
}

export async function getInternalUserById(
  id: number,
): Promise<InternalUserResponse> {
  const { data } = await api.get<InternalUser>(`/user_corporate/${id}`);

  return {
    ...data,
    isActive: isActive(data.status),
    type: 'Interno',
    formattedAccessType: accessTypes[data.accessType as keyof Object],
  };
}

export async function deleteInternalUserById(
  id: number,
): Promise<AxiosResponse<any>> {
  return api
    .put(`/user_customer/${id}/empresas`, [])
    .then(() => api.delete(`/user_corporate/${id}`));
}

export async function updateInternalUserById(
  id: number,
  data: any,
): Promise<AxiosResponse<any>> {
  return api.put(`/user_corporate/${id}`, data);
}

export async function getCompaniesByInternalUser(
  id: number,
): Promise<UserCompanies> {
  const response = await api.get<{ id_empresa: Company }[]>(
    `/user_corporate/${id}/empresas`,
  );
  const companies = response.data.map(company => company.id_empresa);
  const groups: Group[] = [];

  const groupIds = companies
    .filter(c => !!c.grupoeconomico.id_grupoeconomico)
    .map(company => company.grupoeconomico.id_grupoeconomico)
    .reduce(
      (unique: number[], item: number) =>
        unique.includes(item) ? unique : [...unique, item],
      [],
    );

  // eslint-disable-next-line no-restricted-syntax
  for await (const groupId of groupIds) {
    const { data } = await api.get<Group>(`/grupoeconomico/${groupId}`);
    groups.push(data);
  }

  return {
    companies,
    groups,
  };
}
